import React, { useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import GlobalFeedback from "../../../../global/GlobalFeedback";
import ScheduleForm from "./ScheduleForm";
import { createSchedule } from "../../api/schedulesApi";
import { ensureCsrfToken, safeErrorText } from "../../utils/scheduleHelpers";

/** Office — inline schedule entry (mirrors visitor `OfficeRegisterForm`). */
export default function OfficeScheduleForm({ onSuccess }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [formKey, setFormKey] = useState(0);

  const handleCancel = () => {
    setError("");
    setFormKey((k) => k + 1);
  };

  const handleSubmit = async (payload) => {
    setSubmitting(true);
    setError("");
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      const res = await createSchedule(payload, csrfToken);
      onSuccess?.(res?.message || "Schedule created successfully");
    } catch (err) {
      setError(safeErrorText(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <GlobalFeedback type="error" text={error} role="alert" />
      <ScheduleForm
        key={formKey}
        mode="create"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        submitting={submitting}
        serverError={error}
      />
    </>
  );
}
